/**
 * A temporary section on paper (S62, F2; 25-zeitsteuerung.md § 7.6): print, PDF and Word show it with
 * its time as the line under its title (the default), without it („plain“) or not at all („hide“).
 * With the time control off, it is a section like any other.
 */
import type { CardLang } from "./card-lang.ts";
import { daysText, rangeText, windowText } from "./hours.ts";
import type { MenuView } from "./menu.ts";

export function viewForPrint(view: MenuView, lang: CardLang | null | undefined, timed: boolean): MenuView {
  if (!timed || !view.sections.some((s) => s.web)) return view;
  return {
    ...view,
    sections: view.sections.flatMap((s) => {
      if (!s.web || s.web.print === "plain") return [s];
      if (s.web.print === "hide") return [];
      const w = s.web;
      // On a bilingual card (S36) the days in both where they differ: „Mo–Fr / Mon–Fri 11:30–14:30“.
      const line = !lang ? windowText(w, "de") : !lang.both ? windowText(w, lang.lang) : daysText(w.days, "de") === daysText(w.days, lang.lang) ? windowText(w, "de") : `${daysText(w.days, "de")} / ${daysText(w.days, lang.lang)} ${rangeText(w.from, w.to, "de")}`;
      return [{ ...s, note: s.note ? `${line} · ${s.note}` : line }];
    }),
  };
}
